var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C79948E0-0BEE-422C-8153-9D11EF2E40E9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---New-menu-and-order-pages-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products---packaged",
    transform: "translate(-308, -362)",
    fill: "#00414B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(24, 341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "order-icon",
    transform: "translate(284, 21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,18.6666667 C8.9556,18.6666667 8.63893333,18.5389333 8.38333333,18.2833333 C8.12773333,18.0277333 8,17.7110667 8,17.3333333 L8,10.6666667 L1.33333333,10.6666667 C0.95556,10.6666667 0.638893333,10.5389333 0.383333333,10.2833333 C0.127773333,10.0277333 0,9.71106667 0,9.33333333 C0,8.9556 0.127773333,8.63893333 0.383333333,8.38333333 C0.638893333,8.12773333 0.95556,8 1.33333333,8 L8,8 L8,1.33333333 C8,0.95556 8.12773333,0.638893333 8.38333333,0.383333333 C8.63893333,0.127773333 8.9556,0 9.33333333,0 C9.71106667,0 10.0277333,0.127773333 10.2833333,0.383333333 C10.5389333,0.638893333 10.6666667,0.95556 10.6666667,1.33333333 L10.6666667,8 L17.3333333,8 C17.7110667,8 18.0277333,8.12773333 18.2833333,8.38333333 C18.5389333,8.63893333 18.6666667,8.9556 18.6666667,9.33333333 C18.6666667,9.71106667 18.5389333,10.0277333 18.2833333,10.2833333 C18.0277333,10.5389333 17.7110667,10.6666667 17.3333333,10.6666667 L10.6666667,10.6666667 L10.6666667,17.3333333 C10.6666667,17.7110667 10.5389333,18.0277333 10.2833333,18.2833333 C10.0277333,18.5389333 9.71106667,18.6666667 9.33333333,18.6666667 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconTeal);
export default __webpack_public_path__ + "static/media/plus-icon-teal.e814b1fd0c418af3d4a900013c9c4fc1.svg";
export { ForwardRef as ReactComponent };